/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jobhuntingdifficulties2Inputs */

const en__field_jobhuntingdifficulties2 = /** @type {(inputs: _Field_Jobhuntingdifficulties2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobhunting Difficulties?`)
};

const de__field_jobhuntingdifficulties2 = /** @type {(inputs: _Field_Jobhuntingdifficulties2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Schwierigkeiten hast du bei der Jobsuche?`)
};

/**
* | output |
* | --- |
* | "Jobhunting Difficulties?" |
*
* @param {_Field_Jobhuntingdifficulties2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_jobhuntingdifficulties2 = /** @type {((inputs?: _Field_Jobhuntingdifficulties2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jobhuntingdifficulties2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_jobhuntingdifficulties2(inputs)
	return de__field_jobhuntingdifficulties2(inputs)
});
export { _field_jobhuntingdifficulties2 as "_field_jobHuntingDifficulties" }